import { ReactElement } from 'react';

import { Container } from 'components/Container';
import { CmsApiPage } from 'modules/cms/api/types/CmsApiPage';
import { CmsSidebar } from 'modules/cms/components/Sidebar';
import { CmsSidebarBlockComponent } from 'modules/cms/components/SidebarBlockComponent';

type Props = {
  content: CmsApiPage;
};

export function CmsLowerSidebar({ content }: Props): ReactElement {
  return (
    <CmsSidebar>
      {content.sidebar.contentBlocksBottom.map((block, index) => (
        <Container key={block.id}>
          <CmsSidebarBlockComponent
            content={content}
            block={block}
            index={index}
          />
        </Container>
      ))}
    </CmsSidebar>
  );
}
